import { render, staticRenderFns } from "./OrganizationIcon.vue?vue&type=template&id=567fb9e6&"
import script from "./OrganizationIcon.vue?vue&type=script&lang=js&"
export * from "./OrganizationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports